import React, {useState, useEffect} from 'react';
import {Link, generatePath, useHistory, useParams} from "react-router-dom";
import { useDataValue } from 'globals/contexts/dataContext';

import ProjectWrapper from 'components/projectWrapper';

import routes from 'globals/routes';

import './artShowcase.css';
import './artShowcaseMobile.css';
const ArtShowcase = ({content: pageContent}) => {
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const [activeProject, setActiveProject] = useState(null);
  const [currentPhotoOffset, setCurrentPhotoOffset] = useState(null);
  const history = useHistory();
  const { filter: currentFilter } = useParams();
  const currentProject = pageContent['projects'].filter((project) => project['type'] === currentFilter);
  const currentStyle = pageContent['filter'].find((e) => e.type === currentFilter);
  const logoUrl = content['logo'];
  const navigateTo = (filter) => {
    dispatch({
      type: 'pageTransitionStart',
    });
    setTimeout(() => {
      history.push(routes.pageWithLangAndFilter('art', currentLanguage, filter));
      dispatch({
        type: 'pageTransitionEnd'
      });
    }, 1500);
  }
  const navigatePrevSlide = () => {
    setCurrentPhotoOffset(prevPhotoOffset => {
      return Math.max(0, prevPhotoOffset - 1);
    });
  }
  const navigateNextSlide = () => {
    setCurrentPhotoOffset(prevPhotoOffset => {
      const selectedProject = pageContent['projects'].find(project=>project['id'] === activeProject);
      if (selectedProject) {
        return Math.min(prevPhotoOffset + 1, selectedProject['images'].length - 1);
      } else {
        return prevPhotoOffset;
      }
    });
  }
  useEffect(() => {
    setCurrentPhotoOffset(0);
  }, [activeProject]);
  return <section className="artShowcase">
    <div className="landing">
      {{
        video: <video className="coverVideo" src={currentStyle['background']['src']} autoPlay muted playsInline loop />,
        image: <img className="coverImage" src={currentStyle['background']['src']} />
      }[currentStyle['background']['type']]}
      <div className="dimCover" />
      <div className="logo">
        <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
          <img src={logoUrl} />
        </Link>
      </div>
      <div className="fontInfo" key={currentStyle['type']}>
        <div className="nameIcon">
          <img src={currentStyle['icon']} />
        </div>
        <div className="nameText">
          <div className="name1">{currentStyle['text']}</div>
          <div className="name2">{currentStyle['text2']}</div>
        </div>
      </div>
      <div className="introduction" dangerouslySetInnerHTML={{
        __html: currentStyle['description']
      }} />
    </div>
    <div className="listingWrapper">
      <ProjectWrapper 
        items={currentProject} 
        selectedFilter={null} 
        onProjectClick={setActiveProject}
        ProjectInfoRenderer = {({project}) => {
          return <div className="projectInfo">
            <div className="name">
              {project['name']}
            </div>
            <div className="line" />
            <div className="count">{project['images'].length + (currentLanguage==="tc"? " 張相片": " photos")}</div>
          </div>;
        }}
      />
    </div>
    
    <div className="filtersWrapper">
      <div className="filterLabel">{pageContent['exploreLabel']}</div>
      <div className="filters">
        {pageContent['filter'].map(item => {
          if (item['type'] !== currentFilter) {
            return <div key={item['type']}
              className="filter"
              onClick={() => navigateTo(item['type'])}
            >
              <div className="styleIcon" style={{
                backgroundImage: `url(${item['icon']})`
              }} />
              <div className="name">
                <div className="line1">{item['text']}</div>
                <div className="line2">{item['text2']}</div>
              </div>
              <div className="clickHint">{pageContent['buttonLabel']}</div>
            </div>;
          } else {
            return null;
          }
        })}
      </div>
      {activeProject && 
        <div className="imageViewer">
          <div className="imageViewerBackground" onClick={()=>setActiveProject(null)} />
          <div className="closeBtn" onClick={()=>setActiveProject(null)} />
          {pageContent['projects'].find(project=>project['id'] === activeProject)['images'].length > 1 && <>
            <div className={`imageNavigate navigateLeft${currentPhotoOffset === 0? ' disabled': ''}`}
            onClick={navigatePrevSlide} 
          />
            <div className={`imageNavigate navigateRight${currentPhotoOffset === pageContent['projects'].find(project=>project['id'] === activeProject)['images'].length - 1 ? ' disabled': ''}`}
            onClick={navigateNextSlide} 
          />
          </>}
          {pageContent['projects'].filter(project=>project['id'] === activeProject).map(project => {
            return <div className="imagesWrapper"
              key={project['id']}
              style={{
                transform: `translate(-${currentPhotoOffset * 100}%)`
              }}
            >
              
              {project['images'].map((image, idx) => {
                return <img className="image" draggable={false} onClick={()=>false} src={image} key={idx} />
              })}
              </div>
          })}
        </div>
      }
    </div>

  </section>;
}

export default ArtShowcase;